import { KC_COLORS } from '../theme';
import { resolveKcArticleImage } from './kcArticleImages';

/**
 * Article diagram — rendered in the body after Executive Framework.
 */
export function ArticleFigure({ figure, className = '' }) {
  if (!figure) return null;

  const src = resolveKcArticleImage(figure.image);
  if (!src) return null;

  return (
    <figure className={`kc-article-figure m-0 w-full text-left ${className}`.trim()}>
      <div
        className="relative w-full overflow-hidden rounded-2xl border bg-white shadow-[0_8px_24px_rgba(10,29,58,0.08)]"
        style={{ borderColor: KC_COLORS.border }}
      >
        <div
          className="h-1 w-full"
          style={{
            background: `linear-gradient(90deg, ${KC_COLORS.teal} 0%, ${KC_COLORS.primaryNavy} 100%)`,
          }}
          aria-hidden
        />
        <div
          className="w-full overflow-x-auto overscroll-x-contain"
          style={{
            backgroundColor: KC_COLORS.lightGrey,
            WebkitOverflowScrolling: 'touch',
          }}
        >
          <img
            src={src}
            alt={figure.alt || figure.title || 'Article diagram'}
            className="block w-full h-auto max-w-full object-contain object-center"
            loading="eager"
            decoding="async"
          />
        </div>
      </div>
      {figure.caption ? (
        <figcaption
          className="mt-3 md:mt-3.5 kc-type-caption text-left max-w-4xl"
          style={{ color: KC_COLORS.gray600 }}
        >
          {figure.caption}
        </figcaption>
      ) : null}
    </figure>
  );
}
